<app-header></app-header>
<div class="login-container">
  <div class="logo">
    <img src="/images/logo-v2.png" alt="WealthLane" />
  </div>

  <h2>Se <span>connecter</span></h2>

  <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
    <div class="form-group">
      <label for="email">Email</label>
      <input type="email" formControlName="email" (input)="clearErrors()" />
    </div>
    <div class="error-message" *ngIf="submitted && loginForm.controls['email'].errors?.['required']">
      Email est requis
    </div>
    <div class="error-message" *ngIf="submitted && loginForm.controls['email'].errors?.['email']">
      Email est invalide
    </div>

    <div class="form-group">
      <label for="password">Mot de passe</label>
      <input type="password" formControlName="password" (input)="clearErrors()" />
    </div>
    <div class="error-message" *ngIf="submitted && loginForm.controls['password'].errors?.['required']">
      Mot de passe est requis
    </div>

    <div class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <button type="submit" [disabled]="loading" class="submit-btn">Se connecter</button>

    <a class="forgot-password">Mot de passe oublié</a>

    <div class="separator">ou</div>


    <div class="google-auth-container">
      <button type="button" class="google-btn" (click)="loginWithGoogle()">
        Se connecter avec Google
        <img src="/images/google-icn.png" alt="Google" />
      </button>
      <asl-google-signin-button type='standard' size='large' shape='pill' theme='outline'>
      </asl-google-signin-button>
    </div>

    <div class="signup-link">
      <a routerLink="/register">Créer un compte</a>
    </div>
  </form>
</div>
<app-footer></app-footer>